'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var reactIntl = require('react-intl');
var moment = _interopDefault(require('moment-timezone'));
var LiveClock = require('../../LiveClock/LiveClock.js');
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');
var TimeTableCell = require('./components/TimeTableCell.js');

var DayScheduleCalendar = function (props) {
    var columnNamingFn = props.columnNamingFn, columns = props.columns, componentFunction = props.componentFunction, events = props.events, _a = props.resetScroll, resetScroll = _a === void 0 ? 'firstEvent' : _a, _b = props.resetScrollBehavior, resetScrollBehavior = _b === void 0 ? 'auto' : _b, resetScrollCoordinates = props.resetScrollCoordinates, currentTime = props.currentTime, _c = props.timezone, timezone = _c === void 0 ? 'America/Los_Angeles' : _c, _d = props.showCurrentTimeLine, showCurrentTimeLine = _d === void 0 ? false : _d;
    var theme = core.useTheme();
    var fm = reactIntl.useIntl().formatMessage;
    var columnNames = utils.getColumnNames(columns, columnNamingFn);
    var fiveMinuteTimeIntervals = utils.getFiveMinuteTimeIntervals();
    var basicTableCells = utils.tableCellGenerator(columns, theme);
    var columnData = utils.generateColumnsGiven(basicTableCells, componentFunction, theme, events);
    var calendarEl = React.useRef(null);
    var calendarTableBodyRef = React.useRef(null);
    var calendarTableHeaderRef = React.useRef(null);
    var scrollTo = React.useCallback(function (scrollPosition) {
        var _a;
        if (resetScrollBehavior === 'none')
            return;
        var scrollTarget = (_a = calendarEl.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        var scrollOptions = utils.getScrollOptions(scrollPosition, resetScrollBehavior, scrollTarget, calendarTableHeaderRef, calendarTableBodyRef, timezone, events, resetScrollCoordinates);
        if (scrollTarget && scrollOptions && typeof scrollTarget.scrollTo === 'function') {
            scrollTarget.scrollTo(scrollOptions);
        }
    }, [resetScrollBehavior, timezone, events, resetScrollCoordinates]);
    React.useEffect(function () {
        if (!resetScroll || resetScrollBehavior === 'none')
            return;
        scrollTo(resetScroll);
    }, [resetScroll, resetScrollBehavior, scrollTo]);
    var _e = React.useState(undefined), initialPosition = _e[0], setInitialPosition = _e[1];
    React.useLayoutEffect(function () {
        setInitialPosition(utils.getTimeLinePositionInPx(moment(currentTime).tz(timezone), calendarTableHeaderRef, calendarTableBodyRef));
    }, [currentTime, utils.getTimeLinePositionInPx]);
    return (React__default.createElement(styledComponents.StyledTable, { ref: calendarEl },
        React__default.createElement(core.TableHead, { ref: calendarTableHeaderRef },
            React__default.createElement(core.TableRow, null,
                React__default.createElement(styledComponents.TimeTitleTableCell, null, fm({ id: 'componentLib.appWide.time' })),
                columnNames.map(function (name) { return (React__default.createElement(styledComponents.TitleTableCell, { key: name, style: { textAlign: 'center', width: utils.getChairColumnWidth(columns) } }, name)); }))),
        React__default.createElement(core.TableBody, { ref: calendarTableBodyRef },
            showCurrentTimeLine && (React__default.createElement(LiveClock, { timezone: timezone, startTime: currentTime, render: function (time) {
                    var position = utils.getTimeLinePositionInPx(time, calendarTableHeaderRef, calendarTableBodyRef);
                    return (React__default.createElement(styledComponents.CurrentTimeHorizontalLine, { "aria-hidden": 'true', style: { top: position || initialPosition }, "data-testid": 'current-time-line' }));
                } })),
            fiveMinuteTimeIntervals.map(function (interval, i) {
                return (React__default.createElement(core.TableRow, { "data-key": interval.hr + "-" + interval.min, key: interval.hr + "-" + interval.min, style: { height: '12px' } },
                    React__default.createElement(TimeTableCell, { interval: interval, key: interval.hr + ":" + interval.min }),
                    columnData.map(function (columnOfEvents) { return columnOfEvents[i]; })));
            }))));
};

module.exports = DayScheduleCalendar;
